import type { FC, ReactNode } from 'react'

import { useState } from 'react'

import { cn } from '@/lib/utils'
import { faqs } from '@/constants/metric'
import { SectionHeading } from '@/components/generals/section-heading'

export const FaqSection: FC = (): ReactNode => {
    const [open, setOpen] = useState(0)

    return (
        <section id='faq' aria-labelledby='faq-title' className='scroll-mt-[96px] px-0 py-20 tab:px-[60px] tab:py-28'>
            <div className='fw-container flex flex-col items-center gap-12 tab:gap-16'>
                <SectionHeading
                    tag='FAQ'
                    title={<span id='faq-title'>Everything you need to know</span>}
                    description='Everything worth knowing before you book a seat.'
                />

                <ul className='flex w-full max-w-[860px] flex-col gap-3'>
                    {faqs.map((faq, index) => {
                        const isOpen = open === index

                        return (
                            <li
                                key={faq.question}
                                data-reveal='up'
                                data-reveal-delay={0.04 * index}
                                className={cn(
                                    'overflow-hidden rounded-[9px] border transition-colors duration-500',
                                    isOpen ? 'border-[#454545] bg-surface' : 'border-line bg-[#0d0d0d] hover:border-[#454545]'
                                )}
                            >
                                <h3>
                                    <button
                                        type='button'
                                        aria-expanded={isOpen}
                                        aria-controls={`faq-panel-${index}`}
                                        id={`faq-trigger-${index}`}
                                        onClick={() => setOpen(isOpen ? -1 : index)}
                                        className='flex w-full items-center justify-between gap-5 px-5 py-5 text-left'
                                    >
                                        <span className='font-sans text-[17px] font-medium leading-[1.3em] text-ink tab:text-[19px]'>
                                            {faq.question}
                                        </span>

                                        <span
                                            aria-hidden='true'
                                            className='relative flex h-[30px] w-[30px] shrink-0 items-center justify-center rounded-full border border-line'
                                        >
                                            <span className='absolute block h-px w-[11px] bg-ink' />

                                            <span
                                                className={cn(
                                                    'absolute block h-px w-[11px] bg-ink transition-transform duration-500 ease-[cubic-bezier(0.16,1,0.3,1)]',
                                                    isOpen ? 'rotate-0' : 'rotate-90'
                                                )}
                                            />
                                        </span>
                                    </button>
                                </h3>

                                <div
                                    id={`faq-panel-${index}`}
                                    role='region'
                                    aria-labelledby={`faq-trigger-${index}`}
                                    className={cn(
                                        'grid transition-[grid-template-rows,opacity] duration-500 ease-[cubic-bezier(0.16,1,0.3,1)]',
                                        isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                                    )}
                                >
                                    <div className='overflow-hidden'>
                                        <p className='px-5 pb-5 font-body text-[16px] leading-[1.45em] text-ink-soft'>
                                            {faq.answer}
                                        </p>
                                    </div>
                                </div>
                            </li>
                        )
                    })}
                </ul>
            </div>
        </section>
    )
}
